module.exports = __webpack_public_path__ + "img/biznis-hosting.9f3579a6.svg";